import { useBrandingContext } from '@group-link-one/gl-components';
import { Outlet } from 'react-router-dom';

import { type IBranding } from '@/Branding';
import { OnboardTemplate } from '@/Templates/Onboard/Onboard.template';

export const OnboardLayout = () => {
  const { brandingData } = useBrandingContext() as { brandingData: IBranding };

  return (
    <OnboardTemplate
      BrandingName={brandingData.BrandingName}
      Theme={brandingData.Theme}
      Onboard={brandingData.Onboard}
      Groups={brandingData.Groups}
      BatchImport={brandingData.BatchImport}
      Projections={brandingData.Projections}
      FallBack={brandingData.FallBack}
      ModalLogout={brandingData.ModalLogout}
    >
      <Outlet />
    </OnboardTemplate>
  );
};
